package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.styles.TextEditorSeparatorStyle
import io.horion.cv.styles.TextEditorToolbarRowStyle
import io.horion.cv.styles.VerticalDividerStyle
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.px

@Composable
fun TextEditorToolbar(
    isBold: Boolean, onBoldClick: () -> Unit,
    isItalic: Boolean, onItalicClick: () -> Unit,
    isUnderline: Boolean, onUnderlineClick: () -> Unit,
    isBulletList: Boolean, onBulletClick: () -> Unit,
    isNumberedList: Boolean, onNumberedClick: () -> Unit,
    alignment: TextAlignment, onAlignmentChange: (TextAlignment) -> Unit,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .styleModifier {
                property("min-width", "0")
                property("box-sizing", "border-box")
            }
    ) {
        Box(
            modifier = TextEditorSeparatorStyle.toModifier()
                .backgroundColor(Colors.Graytext)
        )

        Row(
            modifier = TextEditorToolbarRowStyle
                .toModifier()
                .styleModifier {
                    property("min-width", "0")
                    property("box-sizing", "border-box")
                    property("overflow", "visible")
                    property("position", "relative")
                    property("z-index", "10")
                    property("flex-wrap", "wrap")
                    property("row-gap", "6px")
                },
            horizontalArrangement = Arrangement.spacedBy(10.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            ToolbarIcon("/bold.svg", "Gras", isBold) { onBoldClick() }
            ToolbarIcon("/italic.svg", "Italic", isItalic) { onItalicClick() }
            ToolbarIcon("/underline.svg", "Souligner", isUnderline) { onUnderlineClick() }

            Box(
                modifier = Modifier
                    .width(1.px)
                    .height(25.px)
                    .backgroundColor(Colors.Graytext)
                    .styleModifier {
                        property("flex-shrink", "0")
                    }
            )

            ToolbarIcon("/list-bullet.svg", "Liste", isBulletList) { onBulletClick() }
            ToolbarIcon("/list-number.svg", "Liste numérotée", isNumberedList) { onNumberedClick() }

            Box(
                modifier = VerticalDividerStyle
                    .toModifier()
                    .backgroundColor(Colors.Graytext)
                    .styleModifier {
                        property("flex-shrink", "0")
                    }
            )

            AlignmentDropdown(
                current = alignment,
                onChange = onAlignmentChange
            )
        }
    }
}